module.exports = __webpack_public_path__ + "img/083.27b9eb94.jpeg";